import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

const zh = {

    ...zhLocale
};
export default zh;
